import { useContext } from 'react';
import { ToastContext } from '../contexts/ToastContext';

export default function UseToast() {
  const { toast, addToast, removeToast } = useContext(ToastContext);
  return { toast, addToast, removeToast };
}
